import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/auth",
    name: "Auth",
    component: () => import("@/views/Auth/index.vue"),
  },
  // {
  //   path: "/tvs-table",
  //   name: "FeedbackTvsTable",
  //   component: () => import("@/views/Feedback/FeedbackTvsTable.vue"),
  // },
  {
    path: "/tvs-table",
    name: "TvsEmbed",
    component: () => import("@/views/Rating/AestheticGroupGymnastics/Tvs/TvsEmbedView.vue"),
  },
  {
    path: "/avbs-table",
    name: "AvBsEmbed",
    component: () => import("@/views/Rating/AestheticGroupGymnastics/AV-BS/AvBsEmbedView.vue"),
  },
  {
    path: "/",
    component: () => import("@/views/Performances.vue"),
    children: [
      {
        path: "",
        name: "ListPerformances",
        component: () => import("@/views/ListPerformances/index.vue"),
      },
      {
        path: ":performanceId",
        name: "RatingController",
        props: ({ params }) => ({
          performanceId: parseInt(
            Array.isArray(params.performanceId) ? params.performanceId[0] : params.performanceId
          ),
        }),
        component: () => import("@/views/Rating/RatingController.vue"),
      },
    ],
  },
];

export default routes;
